export const PLOT_AREA_WIDTH = 601
export const PLOT_AREA_HEIGHT = 160
export const PLOT_AREA_PADDING_TOP = 37
export const PLOT_AREA_PADDING_RIGHT = 22
export const PLOT_AREA_PADDING_LEFT = 0
export const X_AXIS_HEIGHT = 40
export const Y_AXIS_WIDTH = 80

export const TIMEFRAME_OPTIONS = [
  {
    value: '7',
    label: '6 months',
  },
  {
    value: '13',
    label: '1 year',
  },
  {
    value: '25',
    label: '2 years',
  },
]
